import * as React from "react";
import {
  List, Datagrid, TextField, NumberField, SelectInput, SearchInput,
  Show, SimpleShowLayout,
} from "react-admin";
import { FrDateField } from "../../components/FrDateField";
import { TechInfo } from "../../components/ui";

// File des emails (GET /admin/email-outbox) : envoyés / en attente / échoués.
const filters = [
  <SearchInput key="q" source="q" alwaysOn />,
  <SelectInput key="status" source="status" label="Statut" choices={[
    { id: "PENDING", name: "En attente" },
    { id: "SENT", name: "Envoyé" },
    { id: "FAILED", name: "Échoué" },
  ]} />,
];

export default {
  list: () => (
    <List filters={filters} sort={{ field: "createdAt", order: "DESC" }} perPage={50} title="File d'emails">
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="toEmail" label="Destinataire" />
        <TextField source="subject" label="Sujet" />
        <TextField source="emailType" label="Type" />
        <TextField source="status" label="Statut" />
        <NumberField locales="fr-FR" source="tries" label="Essais" />
        <FrDateField source="createdAt" label="Créé le" showTime />
        <FrDateField source="sentAt" label="Envoyé le" showTime />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <SimpleShowLayout>
        <TextField source="toEmail" label="Destinataire" />
        <TextField source="subject" label="Sujet" />
        <TextField source="emailType" label="Type" />
        <TextField source="status" label="Statut" />
        <NumberField locales="fr-FR" source="tries" label="Essais" />
        <TextField source="lastError" label="Dernière erreur" />
        <FrDateField source="createdAt" label="Créé le" showTime />
        <FrDateField source="sentAt" label="Envoyé le" showTime />
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
};
